import React, { useEffect, useState } from 'react'
import { history } from '../../../../_helpers'
import { Helmet } from 'react-helmet'

import ROUTES from '../../../../_constants/routes'

// Services
import { getInvoiceSchedule } from '../../../../_services/lender.service'

import { SectionLoader } from '../../../../_components/SectionLoader'
import { PageContents } from '../../../../_components/layout/PageContents'
import { ContentColumn } from '../../../../_components/layout/ContentColumn'
import { ClientInvoiceCreate } from '../../../../ClientInvoiceCreate/ClientInvoiceCreate'
import { ClientInvoiceScheduleCreate } from '../ClientInvoiceScheduleCreate'
import { ClientInvoiceScheduleCreateRedesign } from '../ClientInvoiceScheduleCreateRedesign'
import { Button } from '../../../../_components/Button'
import { InfoModal } from '../../../../_components/modals/info/InfoModal'
import { CreateInvoices } from '../../common/CreateInvoices/CreateInvoicesNew'
import { CreateInvoicesRedesign } from '../../common/CreateInvoicesRedesign/CreateInvoicesNew'

// Styles
import { S_PageHeader } from '../../../../_components/layout/PageHeader/PageHeader.styles'

import { isFeatureEnabled } from '../../../../_helpers/flags'
import { useFlags } from '../../../../_reduxHooks/flags.hook'
import { useBusiness } from '../../../../_reduxHooks/business.hook'
import { useModal } from '../../../../_reduxHooks/modal.hook'
import { COMPANY_NAME } from 'xen/constants'

export const ClientInvoiceSchedule = ({ match }) => {
  const { featureFlags } = useFlags()
  const isNewSchedulePage = isFeatureEnabled('schedule_page_new', featureFlags)
  const isNewInvoiceRedesign = isFeatureEnabled('new_invoice_redesign', featureFlags)

  const [reloadSchedule, setReloadSchedule] = useState(false)

  const [invoiceSchedule, setInvoiceSchedule] = useState(null)
  const [disabled, setDisabled] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const { business } = useBusiness()

  const scheduleId = match.params.schedule_id
  const newSchedule = scheduleId === 'create'

  const { openModal } = useModal()

  const reloadSchedulePage = (action = '') => {
    if (action === 'redirect_to_client_home') {
      history.push(ROUTES.client_home)

      openSuccessModal()
      return
    }
    setReloadSchedule((reload) => !reload)
  }

  const openSuccessModal = () => {
    const message = `The Invoice Schedule was submitted successfully.`

    openModal(InfoModal, {
      content: message,
      buttonText: 'Close',
    })
  }

  useEffect(() => {
    if (!isNewSchedulePage) {
      setIsLoading(false)
      return
    }

    setIsLoading(true)
    if (newSchedule) {
      setIsLoading(false)
      return
    }
    getInvoiceSchedule(scheduleId).then(async (resp) => {
      setInvoiceSchedule(resp)
      setDisabled(resp.state !== 'incomplete')
      setIsLoading(false)
    })
  }, [reloadSchedule, scheduleId])

  if (!isNewSchedulePage) {
    return <ClientInvoiceCreate match={match} />
  }

  if (newSchedule) {
    return isNewInvoiceRedesign ? (
      <ClientInvoiceScheduleCreateRedesign setIsLoading={setIsLoading} />
    ) : (
      <ClientInvoiceScheduleCreate setIsLoading={setIsLoading} />
    )
  }

  if (isLoading) {
    return <SectionLoader />
  }

  return (
    <PageContents>
      <Helmet>
        <title>Invoice Schedule • {COMPANY_NAME}</title>
      </Helmet>

      <ContentColumn>
        <S_PageHeader>
          <Button buttonType="link" className="link" to={ROUTES.client_home}>
            Back to summary
          </Button>
        </S_PageHeader>
        {isNewInvoiceRedesign ? (
          <CreateInvoicesRedesign
            business={business}
            invoiceSchedule={invoiceSchedule}
            isClientView={true}
            isDisabled={disabled}
            reloadSchedulePage={reloadSchedulePage}
          />
        ) : (
          <CreateInvoices
            business={business}
            invoiceSchedule={invoiceSchedule}
            isClientView={true}
            isDisabled={disabled}
            reloadSchedulePage={reloadSchedulePage}
          />
        )}
      </ContentColumn>
    </PageContents>
  )
}
